module.exports = __webpack_public_path__ + "static/media/C.06c1ad4a.webp";